// extracted by mini-css-extract-plugin
export default {"checkbox":"Form-Checkbox__checkbox--VlN8G"};